<template>
	<span id="timer" style="color: #fff">{{ timer.minutes }}:{{ timer.seconds }}</span>
</template>

<script setup lang="ts">
	import { ref, Ref, inject, onBeforeUnmount } from 'vue';
	import { deadlineTimerEngine, type DeadlineTimerTick } from '../services/deadline_timer_engine';

	const emitter: any = inject('emitter');

	const props = defineProps({
		deadline: { type: String, required: true },
		// Mantido por compatibilidade, mas não é mais usado (o componente sempre usa get_timer_data_url).
		get_time_url: { type: String, required: false, default: null },
		// Endpoint único (retorna server_timestamp e deadline_timestamp já com failures_extra_seconds).
		get_timer_data_url: { type: String, required: true },
	});

	interface Timer {
		minutes: string;
		seconds: string;
	}

	const timer: Ref<Timer> = ref({
		minutes: '00',
		seconds: '00',
	});

	let unsubscribe: (() => void) | null = null;

	function onTick(tick: DeadlineTimerTick) {
		timer.value.minutes = tick.minutes;
		timer.value.seconds = tick.seconds;

		// Regra 3: ao zerar, só redireciona se após a revalidação ainda for 0.
		// Quem controla a revalidação é o engine; quando ele marca expired=true,
		// significa que o remaining continuou 0 após o sync.
		if (tick.remainingMs === 0 && deadlineTimerEngine.claimExpireEmission()) {
			emitter.emit('exam_expired', {
				reason: 'Tempo esgotado! Redirecionando para o encerramento da prova',
				type: 'exam_timeout',
			});
		}
	}

	deadlineTimerEngine.configure(props.get_timer_data_url);
	unsubscribe = deadlineTimerEngine.subscribe(onTick);
	void deadlineTimerEngine.start();

	onBeforeUnmount(() => {
		unsubscribe?.();
		unsubscribe = null;
	});
</script>

<style></style>
